<mat-icon (click)="close()" class="close">close</mat-icon>

@if (items.length>0) {
<app-shopping-cart-shipping-fee-progress
  [subtotal]="subtotal"
></app-shopping-cart-shipping-fee-progress>
<div class="items">
  @for (item of items; track $index) {
  <app-shopping-cart-list-item [item]="item"></app-shopping-cart-list-item>
  }
</div>
<app-shopping-cart-checkout></app-shopping-cart-checkout>

}@else{
<app-shopping-cart-empty></app-shopping-cart-empty>
}
